import { createTheme, type MantineColorsTuple } from "@mantine/core";

// GCP Brand Colors
const gcpBlue: MantineColorsTuple = [
  "#e6e7f5",
  "#c9cceb",
  "#9da2dc",
  "#6f76cd",
  "#4950c1",
  "#2f38ba",
  "#04119A", // Primary brand color
  "#030e7a",
  "#020b5e",
  "#010744",
];

const certaintyColors = {
  high: "#10b981", // Green
  medium: "#f59e0b", // Yellow
  low: "#f97316", // Orange
  none: "#ef4444", // Red
};

export const theme = createTheme({
  primaryColor: "gcpBlue",
  colors: {
    gcpBlue,
  },
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  headings: {
    fontFamily:
      'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontWeight: "600",
  },
  defaultRadius: "md",
  components: {
    Button: {
      defaultProps: {
        size: "md",
      },
    },
    TextInput: {
      defaultProps: {
        size: "md",
      },
    },
    Select: {
      defaultProps: {
        size: "md",
        searchable: true,
        clearable: true,
      },
    },
    Table: {
      defaultProps: {
        striped: true,
        highlightOnHover: true,
      },
    },
  },
  other: {
    certaintyColors,
  },
});
